export class MoneyRangeData {
  private moneyRangeList: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 1),
    new MoneyRangeValue('21,000 - 49,000', 2),
    new MoneyRangeValue('50,000 - 75,000', 3),
    new MoneyRangeValue('75,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 250,000', 5),
    new MoneyRangeValue('250,001 - 500,000', 6),
    new MoneyRangeValue('> 500,000', 7)];

  private netWorthMoneyRangeListUSD: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 0),
    new MoneyRangeValue('$20,001 - $50,000', 3),
    new MoneyRangeValue('$50,001 - $75,000', 4),
    new MoneyRangeValue('$75,001 - $100,000', 5),
    new MoneyRangeValue('$100,001 - $250,000', 6),
    new MoneyRangeValue('$250,001 - $500,000', 7),
    new MoneyRangeValue('$500,001 - $1,000,000', 8),
    new MoneyRangeValue('$1,000,001 - $2,000,000', 9),
    new MoneyRangeValue('$2,000,001 - $5,000,000', 10),
    new MoneyRangeValue('$5,000,001 - $10,000,000', 11),
    new MoneyRangeValue('$10,000,001 - $25,000,000', 12),
    new MoneyRangeValue('$25,000,001 - $30,000,000', 13),
    new MoneyRangeValue('$30,000,001 - $50,000,000', 14),
    new MoneyRangeValue('> $50,000,001', 15)
  ];

  private netWorthLiquidMoneyRangeListUSD: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 0),
    new MoneyRangeValue('$20,001 - $50,000', 3),
    new MoneyRangeValue('$50,001 - $75,000', 4),
    new MoneyRangeValue('$75,001 - $100,000', 5),
    new MoneyRangeValue('$100,001 - $250,000', 6),
    new MoneyRangeValue('$250,001 - $500,000', 7),
    new MoneyRangeValue('$500,001 - $1,000,000', 8),
    new MoneyRangeValue('$1,000,001 - $5,000,000', 9),
    new MoneyRangeValue('> $5,000,001', 10)
  ];

  private annualMoneyRangeListUSD: MoneyRangeValue[] = [
    new MoneyRangeValue('< $39,999', 1),
    new MoneyRangeValue('$40,000 - $45,000', 2),
    new MoneyRangeValue('$45,001 - $50,000', 3),
    new MoneyRangeValue('$50,001 - $100,000', 4),
    new MoneyRangeValue('$100,001 - $150,000', 5),
    new MoneyRangeValue('$150,001 - $200,000', 6),
    new MoneyRangeValue('$200,001 - $250,000', 7),
    new MoneyRangeValue('$250,001 - $500,000', 8),
    new MoneyRangeValue('$500,001 - $1,000,000', 9),
    new MoneyRangeValue('> $1,000,001', 10)];

  private netWorthMoneyRangeListEUR: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 1),
    new MoneyRangeValue('20,001 - 50,000', 2),
    new MoneyRangeValue('50,001 - 75,000', 3),
    new MoneyRangeValue('75,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 200,000', 5),
    new MoneyRangeValue('200,001 - 400,000', 6),
    new MoneyRangeValue('400,001 - 800,000', 7),
    new MoneyRangeValue('800,001 - 2,000,00', 8),
    new MoneyRangeValue('2,000,001 - 4,000,000', 9),
    new MoneyRangeValue('4,000,001 - 10,000,000', 10),
    new MoneyRangeValue('10,000,001 - 25,000,000', 11),
    new MoneyRangeValue('> 25,000,001', 12)
  ];

  private netWorthLiquidMoneyRangeListEUR: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 1),
    new MoneyRangeValue('20,001 - 50,000', 2),
    new MoneyRangeValue('50,001 - 75,000', 3),
    new MoneyRangeValue('75,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 200,000', 5),
    new MoneyRangeValue('200,001 - 400,000', 6),
    new MoneyRangeValue('400,001 - 800,000', 7),
    new MoneyRangeValue('800,001 - 4,000,000', 8),
    new MoneyRangeValue('> 4,000,001', 9)];


  private annualMoneyRangeListEUR: MoneyRangeValue[] = [
    new MoneyRangeValue('< 30,000', 1),
    new MoneyRangeValue('30,001 - 40,000', 2),
    new MoneyRangeValue('40,001 - 45,000', 3),
    new MoneyRangeValue('45,001 - 50,000', 4),
    new MoneyRangeValue('50,001 - 100,000', 5),
    new MoneyRangeValue('100,001 - 150,000', 6),
    new MoneyRangeValue('150,001 - 200,000', 7),
    new MoneyRangeValue('200,001 - 250,000', 8),
    new MoneyRangeValue('250,001 - 500,000', 9),
    new MoneyRangeValue('500,001 - 1,000,000', 10),
    new MoneyRangeValue('> 1,000,001', 11)];

  private netWorthMoneyRangeListCHF: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 1),
    new MoneyRangeValue('20,001 - 50,000', 2),
    new MoneyRangeValue('50,001 - 70,000', 3),
    new MoneyRangeValue('70,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 250,000', 5),
    new MoneyRangeValue('250,001 - 500,000', 6),
    new MoneyRangeValue('500,001 - 1,000,000', 7),
    new MoneyRangeValue('1,000,001 - 5,000,000', 8),
    new MoneyRangeValue('> 5,000,001', 9)];

  private netWorthLiquidMoneyRangeListCHF: MoneyRangeValue[] = [
    new MoneyRangeValue('< 20,000', 1),
    new MoneyRangeValue('20,001 - 50,000', 2),
    new MoneyRangeValue('50,001 - 70,000', 3),
    new MoneyRangeValue('70,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 250,000', 5),
    new MoneyRangeValue('250,001 - 500,000', 6),
    new MoneyRangeValue('500,001 - 1,000,000', 7),
    new MoneyRangeValue('1,000,001 - 5,000,000', 8),
    new MoneyRangeValue('> 5,000,001', 9)];


  private annualMoneyRangeListCHF: MoneyRangeValue[] = [
    new MoneyRangeValue('< 40,000', 1),
    new MoneyRangeValue('40,001 - 45,000', 2),
    new MoneyRangeValue('45,001 - 50,000', 3),
    new MoneyRangeValue('50,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 150,000', 5),
    new MoneyRangeValue('150,001 - 250,000', 6),
    new MoneyRangeValue('250,001 - 500,000', 7),
    new MoneyRangeValue('500,001 - 1,000,000', 8),
    new MoneyRangeValue('> 1,000,001', 9)];

  private netWorthMoneyRangeListGBP: MoneyRangeValue[] = [
    new MoneyRangeValue('< 15,000', 1),
    new MoneyRangeValue('15,001 - 35,000', 2),
    new MoneyRangeValue('35,001 - 50,000', 3),
    new MoneyRangeValue('50,001 - 69,999', 4),
    new MoneyRangeValue('70,000 - 150,000', 5),
    new MoneyRangeValue('150,001 - 300,000', 6),
    new MoneyRangeValue('300,001 - 600,000', 7),
    new MoneyRangeValue('600,001 - 1,500,000', 8),
    new MoneyRangeValue('1,500,001 - 3,000,001', 9),
    new MoneyRangeValue('> 3,000,001', 10)
  ];

  private netWorthLiquidMoneyRangeListGBP: MoneyRangeValue[] = [
    new MoneyRangeValue('< 15,000', 1),
    new MoneyRangeValue('15,001 - 35,000', 2),
    new MoneyRangeValue('35,001 - 50,000', 3),
    new MoneyRangeValue('50,001 - 69,999', 4),
    new MoneyRangeValue('70,000 - 150,000', 5),
    new MoneyRangeValue('150,001 - 300,000', 6),
    new MoneyRangeValue('300,001 - 600,000', 7),
    new MoneyRangeValue('600,001 - 3,000,000', 8),
    new MoneyRangeValue('> 3,000,001', 9)];


  private annualMoneyRangeListGBP: MoneyRangeValue[] = [
    new MoneyRangeValue('< 30,000', 1),
    new MoneyRangeValue('30,001 - 35,000', 2),
    new MoneyRangeValue('35,001 - 50,000', 3),
    new MoneyRangeValue('50,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 150,000', 5),
    new MoneyRangeValue('150,001 - 250,000', 6),
    new MoneyRangeValue('250,001 - 500,000', 7),
    new MoneyRangeValue('500,001 - 1,000,000', 8),
    new MoneyRangeValue('> 1,000,001', 9)];

  private netWorthMoneyRangeListCAD: MoneyRangeValue[] = [
    new MoneyRangeValue('< 25,000', 1),
    new MoneyRangeValue('25,001 - 55,000', 2),
    new MoneyRangeValue('55,001 - 80,000', 3),
    new MoneyRangeValue('80,001 - 95,000', 4),
    new MoneyRangeValue('95,001 - 110,000', 5),
    new MoneyRangeValue('110,001 - 250,000', 6),
    new MoneyRangeValue('250,001 - 500,000', 7),
    new MoneyRangeValue('500,001 - 1,000,000', 8),
    new MoneyRangeValue('1,000,001 - 5,000,000', 9),
    new MoneyRangeValue('> 5,000,001', 10)];

  private netWorthLiquidMoneyRangeListCAD: MoneyRangeValue[] = [
    new MoneyRangeValue('< 25,000', 1),
    new MoneyRangeValue('25,001 - 55,000', 2),
    new MoneyRangeValue('55,001 - 80,000', 3),
    new MoneyRangeValue('80,001 - 95,000', 4),
    new MoneyRangeValue('95,001 - 110,000', 5),
    new MoneyRangeValue('110,001 - 250,000', 6),
    new MoneyRangeValue('250,001 - 500,000', 7),
    new MoneyRangeValue('500,001 - 1,000,000', 8),
    new MoneyRangeValue('1,000,001 - 5,000,000', 9),
    new MoneyRangeValue('> 5,000,001', 10)];


  private annualMoneyRangeListCAD: MoneyRangeValue[] = [
    new MoneyRangeValue('< 45,000', 1),
    new MoneyRangeValue('45,001 - 50,000', 2),
    new MoneyRangeValue('50,001 - 55,000', 3),
    new MoneyRangeValue('55,001 - 100,000', 4),
    new MoneyRangeValue('100,001 - 150,000', 5),
    new MoneyRangeValue('150,001 - 250,000', 6),
    new MoneyRangeValue('250,001 - 500,000', 7),
    new MoneyRangeValue('500,001 - 1,000,000', 8),
    new MoneyRangeValue('> 1,000,001', 9)];

  private netWorthMoneyRangeListILS: MoneyRangeValue[] = [
    new MoneyRangeValue('< 75,000', 1),
    new MoneyRangeValue('75,001 - 150,000', 2),
    new MoneyRangeValue('150,001 - 200,000', 3),
    new MoneyRangeValue('200,001 - 300,000', 4),
    new MoneyRangeValue('300,001 - 400,000', 5),
    new MoneyRangeValue('400,001 - 500,000', 6),
    new MoneyRangeValue('500,001 - 1,000,000', 7),
    new MoneyRangeValue('1,000,001 - 5,000,000', 8),
    new MoneyRangeValue('> 5,000,001', 9)];

  private netWorthLiquidMoneyRangeListILS: MoneyRangeValue[] = [
    new MoneyRangeValue('< 75,000', 1),
    new MoneyRangeValue('75,001 - 150,000', 2),
    new MoneyRangeValue('150,001 - 200,000', 3),
    new MoneyRangeValue('200,001 - 300,000', 4),
    new MoneyRangeValue('300,001 - 400,000', 5),
    new MoneyRangeValue('400,001 - 500,000', 6),
    new MoneyRangeValue('500,001 - 1,000,000', 7),
    new MoneyRangeValue('1,000,001 - 5,000,000', 8),
    new MoneyRangeValue('> 5,000,001', 9)];


  private annualMoneyRangeListILS: MoneyRangeValue[] = [
    new MoneyRangeValue('< 150,000', 1),
    new MoneyRangeValue('150,001 - 200,000', 2),
    new MoneyRangeValue('200,001 - 300,000', 3),
    new MoneyRangeValue('300,001 - 400,000', 4),
    new MoneyRangeValue('400,001 - 500,000', 5),
    new MoneyRangeValue('500,001 - 1,000,000', 6),
    new MoneyRangeValue('> 1,000,000', 7)];

  private yearsTradingData: MoneyRangeValue[] = [
    new MoneyRangeValue('1', 1),
    new MoneyRangeValue('2', 2),
    new MoneyRangeValue('3', 3),
    new MoneyRangeValue('4', 4),
    new MoneyRangeValue('5-9', 5),
    new MoneyRangeValue('> 10', 11)
  ];

  private tradingsPerYear: MoneyRangeValue[] = [
    new MoneyRangeValue('1 - 10', 10),
    new MoneyRangeValue('11 - 25', 25),
    new MoneyRangeValue('26 - 50', 50),
    new MoneyRangeValue('51 - 100', 100),
    new MoneyRangeValue('> 100', 101)
  ];

  public getYearsTradingData(): Array<MoneyRangeValue> {
    return this.yearsTradingData;
  }

  public getTradingsPerYear(): Array<MoneyRangeValue> {
    return this.tradingsPerYear;
  }

  public getMoneyRangeList(): Array<MoneyRangeValue> {
    return this.moneyRangeList;
  }

  public getnetWorthLiquidMoneyRangeList(currency: string): Array<MoneyRangeValue> {
    switch (currency) {
      case 'USD':
        return this.netWorthLiquidMoneyRangeListUSD;
      case 'EUR':
        return this.netWorthLiquidMoneyRangeListEUR;
      case 'CHF':
        return this.netWorthLiquidMoneyRangeListCHF;
      case 'GBP':
        return this.netWorthLiquidMoneyRangeListGBP;
      case 'CAD':
        return this.netWorthLiquidMoneyRangeListCAD;
      case 'ILS':
        return this.netWorthLiquidMoneyRangeListILS;
    }

  }

  public getnetWorthMoneyRangeList(currency: string): Array<MoneyRangeValue> {
    switch (currency) {
      case 'USD':
        return this.netWorthMoneyRangeListUSD;
      case 'EUR':
        return this.netWorthMoneyRangeListEUR;
      case 'CHF':
        return this.netWorthMoneyRangeListCHF;
      case 'GBP':
        return this.netWorthMoneyRangeListGBP;
      case 'CAD':
        return this.netWorthMoneyRangeListCAD;
      case 'ILS':
        return this.netWorthMoneyRangeListILS;
    }
  }

  public getAnnualMoneyRangeList(currency: string): Array<MoneyRangeValue> {
    switch (currency) {
      case 'USD':
        return this.annualMoneyRangeListUSD;
      case 'EUR':
        return this.annualMoneyRangeListEUR;
      case 'CHF':
        return this.annualMoneyRangeListCHF;
      case 'GBP':
        return this.annualMoneyRangeListGBP;
      case 'CAD':
        return this.annualMoneyRangeListCAD;
      case 'ILS':
        return this.annualMoneyRangeListILS;
    }
  }
}

export class MoneyRangeValue {
  rangeName: string;
  rangeValue: number;

  constructor(rangeName: string, rangeValue: number) {
    this.rangeName = rangeName;
    this.rangeValue = rangeValue;
  }
}
